import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as buffer from "buffer";
window.Buffer = buffer.Buffer;
